import React, { useState } from "react";
import OtpInput from "react-otp-input";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import { IMAGES } from "../../../assets/images/images";

const PropertySignUpOTP = () => {
  const [otp, setOtp] = useState("");
  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Form>
                <h1>Confirm Your Number</h1>
                <p className="para">
                  Enter the code we've sent via SMS to +01 123 456 789
                </p>

                <div className="otpBox">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <Button className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100">
                  Continue
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertySignUpOTP;
